import { getHomeDetailsSentenceForEmail, getHomePath } from '@habity/services';
import type { NestedHome } from '@habity/types';

/**
 * Minimal home shape for building the speculator email sentence and URL.
 * Derived from NestedHome; only the fields used by getHomeDetailsSentenceForEmail and getHomePath.
 */
export type HomeForEmailPreview = Pick<
  NestedHome,
  'id' | 'price' | 'is_price_hidden' | 'is_bidding_active'
> & {
  address: Pick<
    NestedHome['address'],
    | 'street'
    | 'city'
    | 'municipality'
    | 'category'
    | 'living_space'
    | 'additional_space'
    | 'rooms'
    | 'monthly_fee'
    | 'area'
  >;
  status: Pick<
    NestedHome['status'],
    'show_address' | 'show_price' | 'allow_indexing'
  >;
};

/**
 * Build home details as a natural sentence (inserted after intro end) and full URL for the plaintext speculator email.
 */
export function buildHomeDetailsAndUrl(
  home: HomeForEmailPreview,
  baseUrl: string
): { detailsSentenceForEmail: string | null; url: string | null } {
  const base = baseUrl.replace(/\/$/, '');
  const homeForServices = {
    ...home,
    address: home.address,
    status: home.status,
    is_bidding_active: home.is_bidding_active ?? false,
  } as unknown as NestedHome;
  const detailsSentenceForEmail = getHomeDetailsSentenceForEmail(homeForServices);
  const path = getHomePath({ id: home.id, address: home.address, status: home.status });
  const url = path ? `${base}${path}` : null;
  return { detailsSentenceForEmail, url };
}
